const MESSAGE = {
  WRONG_AUTH_INFO: 'Đăng nhập thất bại. Hãy Thử lại !!!',
  UNKNOWN_ERROR: 'Có lỗi xãy ra. Vui lòng thử lại sau',
  LOGOUT_SUCCESS: 'Đăng xuất thành công',
  NOT_AUTH: 'Bạn chưa đăng nhập',
};

export default MESSAGE;
